import { render } from "./Argumentation.vue?vue&type=template&id=946b9eea"
import script from "./Argumentation.vue?vue&type=script&setup=true&lang=js"
export * from "./Argumentation.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Question/Argumentation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "946b9eea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('946b9eea', __exports__)) {
    api.reload('946b9eea', __exports__)
  }
  
  module.hot.accept("./Argumentation.vue?vue&type=template&id=946b9eea", () => {
    api.rerender('946b9eea', render)
  })

}


export default __exports__